// src/components/inputs/OptionInput.js
import { Option, Select } from "@material-tailwind/react";
import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { useTopics } from "../hooks/useTopicsSimple";

const OptionInput = ({ label, value, options, onChange }) => {
  const { token } = useParams();
  const isDynamic = options === "topics";

  const { topics = [], loading, error } = useTopics(token);

  const computedOptions = useMemo(() => {
    if (isDynamic) {
      if (loading || error) return [];
      return topics.map((t) => t.name); // Adjust according to your topic structure
    }
    return options;
  }, [isDynamic, loading, error, topics, options]);

  return (
    <div className="mb-4">
      <Select
        value={value}
        onChange={onChange}
        className="w-full"
        label={label}
        placeholder={`Select ${label}`}
        disabled={isDynamic && (loading || error)}
        menuProps={{
          className: "max-h-64 overflow-y-auto custom-scrollbar",
        }}
      >
        {computedOptions.map((option) => (
          <Option key={option} value={option}>
            {option}
          </Option>
        ))}
      </Select>
      {isDynamic && error && (
        <p className="text-red-500 text-sm mt-1">Failed to load topics.</p>
      )}
    </div>
  );
};

OptionInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.string, // For "topics"
    PropTypes.arrayOf(PropTypes.string), // For static options
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
};

OptionInput.defaultProps = {
  value: "",
};

export default OptionInput;
